import ROUTES from '../routes';
import Settings from '../hoc/risk-levels/risk-levels';
import SettingForm from '../hoc/risk-levels/form';

const SettingsRoutes = {
  path: ROUTES.RISK_LEVELS,
  element: <Settings />,
  children: [
    {
      path: ROUTES.RISK_LEVELS_CREATE,
      element: <SettingForm />,
    },
    {
      path: ROUTES.RISK_LEVELS_EDIT,
      element: <SettingForm />,
    },
  ],
};

export default SettingsRoutes;
